import React from 'react';
import { TicketMessageChannel } from 'flow/types/Tickets';
import { Trans } from 'react-i18next';
import useAppContext from 'flow/hooks/useAppContext';
import AllowedFileExtensions from './AllowedFileExtensions';

interface Props {
    channel?: TicketMessageChannel;
    mimeType?: string;
    fileExtensionUserFriendly?: string;
}

const FileTypeNotAllowed = ({
    channel,
    mimeType,
    fileExtensionUserFriendly,
}: Props) => {
    const { i18next } = useAppContext();

    const channeli18Key = getMidPhraseChanneli18Key(channel);
    return (
        <div className="flex flex-col gap-3">
            <p>
                <Trans
                    i18n={i18next}
                    i18nKey={
                        channeli18Key
                            ? 'tickets.input.unsupported_file_type_in_channel'
                            : 'tickets.input.unsupported_file_type'
                    }
                    shouldUnescape={true}
                    values={{
                        fileType: fileExtensionUserFriendly,
                        ...(channeli18Key && {
                            channel: i18next.t(channeli18Key),
                        }),
                    }}
                    components={[<strong key={'ftna-unsupported'} />]}
                />
            </p>
            <AllowedFileExtensions channel={channel} mimeType={mimeType} />
        </div>
    );
};

export default FileTypeNotAllowed;

export const getMidPhraseChanneli18Key = (channel: TicketMessageChannel) => {
    if (channel === 'internal') return 'ticket.note_internal';
    if (channel === 'email') return 'ContactCard.Items.Email';
    if (channel === 'whatsapp') return 'WhatsApp';
    if (channel === 'sms') return 'settings.notifications.device.sms';
    return '';
};
